<template>
    <div>
        <HeaderSection icon="fas fa-user" title="Usuarios">
            <template slot="buttons">
                <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="goToPanel">
                    Regresar
                </el-button>
                <el-button
                        size="medium"
                        type="success"
                        icon="fas fa-user-plus"
                        @click="addUser">
                    Agregar usuario
                </el-button>
            </template>
        </HeaderSection>
        <el-row>
            <el-col :span="5" :offset="19">
                <el-input placeholder="Buscar" v-my-only-alphanumeric="{maxChars: 70}" v-model="search" @keyup.enter.native="handleCurrentChange(1)">
                    <el-button slot="append" :icon="icon" @click="handleCurrentChange(1)"></el-button>
                </el-input>
            </el-col>
            <el-col :span="5" v-if="notApproved > 0">
                <el-alert
                    title="Usuarios no aprobados:"
                    type="info"
                    show-icon>
                                <span>
                                    {{notApproved}}
                                </span>
                </el-alert>
            </el-col>
        </el-row>
        <br>
        <el-table :data="users" border stripe size="mini">
            <el-table-column type="index" label="#"/>
            <el-table-column prop="username" label="Usuario" sortable min-width="70"/>
            <el-table-column prop="full_name" label="Nombre" min-width="150" sortable/>
            <el-table-column prop="email" min-width="150" label="Correo Electrónico"  sortable/>
            <el-table-column prop="isForeign" min-width="150" label="Nacional/Extranjero" sortable>
                <template slot-scope="props">
                    {{props.row.isForeign ? 'Extranjero' : 'Nacional'}}
                </template>
            </el-table-column>
            <el-table-column prop="profile.name" min-width="100" label="Perfil" sortable>
                <template slot-scope="scope">
                    <p v-if="scope.row.cat_profile_id == 5">
                        Perfil: <b>{{scope.row.profile.name}}</b> <br>
                        Banco: <b>{{scope.row.bank ? scope.row.bank.name : ''}}</b>
                    </p>
                    <p v-if="scope.row.cat_profile_id == 6">
                        Perfil: <b>{{scope.row.profile.name}}</b><br>
                        No. de Corredor Público: <b>{{scope.row.publicHallNumber}}</b>
                    </p>
                    <p v-if="scope.row.cat_profile_id == 7">
                        Perfil: <b>{{scope.row.profile.name}}</b><br>
                        Notaria: <b>{{scope.row.notary ? scope.row.notary.name : ''}}</b>
                    </p>
                    <p v-if="scope.row.cat_profile_id < 5">
                        {{scope.row.profile.name}}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="office.name" min-width="100" label="Oficina" sortable/>
            <el-table-column label="Opciones" min-width="40" width="120">
                <template slot-scope="scope">
                    <user-actions
                            :user="scope.row"
                            :key="scope.row.id"
                            :index="scope.$index"
                            @reload-users="getUsers">
                    </user-actions>
                </template>
            </el-table-column>
        </el-table>
        <br>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, ->, prev, pager, next"
                :total="total"
                :page-size="perPage">
        </el-pagination>
    </div>
</template>

<script>
    import HeaderSection from '../../../partials/HeaderSection'
    import UserActions from './partials/UserActions';

    export default {
        components: {
            HeaderSection,
            UserActions
        },

        data() {
            return {
                users: [],
                search: '',
                icon: 'el-icon-search',
                currentPage: 1,
                perPage: 100,
                total: 0,
                notApproved: 0
            }
        },
    created(){
            this.getUsers();
    },
        methods: {

            getUsers(page=1) {

                this.icon = 'fa fa fa-spinner fa-spin';
                this.$store.dispatch(
                    'loading/spinner', { msg: 'Cargando Datos...', status: true }, { root: true });

                axios.get(`/api/users?page=${page}&search=${this.search}&per=${this.perPage}`)
                    .then(response => {

                        this.users        = response.data.users.data;
                        this.total		 = response.data.users.total;
                        this.currentPage	 = response.data.users.current_page;
                        this.perPage   	 = response.data.users.per_page;
                        this.notApproved = response.data.notApproved

                        this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.icon = 'el-icon-search';

                    }).catch(error => {
                    this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$notify.error({
                        title: 'Error',
                        message: 'Error inesperado'
                    });

                });

            },

            goToPanel() {
                this.$router.push('/');
            },

            addUser() {
                this.$router.push('/administracion/usuarios/crear');
            },

            handleCurrentChange(page) {
                this.getUsers(page);
            },

            deleteUser(index) {
                this.users.splice(index, 1);
            }
        }
    }
</script>

<style>
</style>
